import React from 'react'
import ContainerTech from './ContainerTech'



function Technical() {
    return (
        <div id="tech" className="w-full min-h-screen bg-gray-100 bg-grey-50 pt-10 dark:bg-gray-900">
        <ContainerTech />
        </div>
    )
}

export default Technical
